import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProfileView from "../../components/Myaccount/ProfileView"
import BreadComp from "../../components/Myaccount/BreadComp";
import { MediaQueries } from "../../components/utils";
const MobileProfileView = () => {
    const { isMobile } = MediaQueries()
    return (
        < >
            <Container fluid className="homepagecontainer">
                <Row className={!isMobile ? "mt-4" : ""}>
                    <Col lg={12}>
                        <BreadComp title={"Profile"} />
                        <div className="page-titile">Profile</div>
                        <ProfileView />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MobileProfileView;
